export class ControlSettingsSectionModel {
    Name:string;
    Order:number;

    constructor(name:string, order:number){
        this.Name = name;
        this.Order = order;
    }

    static map(section: any): ControlSettingsSectionModel {
        return new ControlSettingsSectionModel(section.Name, section.Order);
    }
}
